import { useState } from 'react';
import PopUpBasic from '../../components/popup/PopUpBasic';

import { useUpdateTradingPhotoCardsMutation } from '../hooks/useUpdateTradingPhotoCardsMutation';
import { extractPrice } from '../../../utils/TextUtil';
import { t } from 'i18next';
import CurrencyInput, { type IntlConfig } from 'react-currency-input-field';
import useUserQuery from '../../hooks/queries/useUserQuery';
import { intlConfig } from '../../../utils/CurrencyUtil';
import { formatInitialPrice } from '../utils/formatCurrency';

interface PriceChangePopUpProps {
  price: string;
  tradingPhotoCardId: string;
  category: string;
  status: string;
  onClose: () => void;
}

const PriceChangePopUp = ({
  price,
  tradingPhotoCardId,
  category,
  status,
  onClose
}: PriceChangePopUpProps) => {
  const [newPrice, setNewPrice] = useState(formatInitialPrice(price) ?? '');

  const user = useUserQuery();
  const { mutate: updateTradingPhotoCards } = useUpdateTradingPhotoCardsMutation();

  const handleEditConfirm = () => {
    try {
      updateTradingPhotoCards({
        tradingPhotoCardId,
        price: newPrice.trim() === '' ? null : extractPrice(newPrice),
        category,
        status
      });
    } catch (error) {
      console.error('Error updating trading photo card:', error);
    } finally {
      onClose();
    }
  };

  const handleEditCancel = () => {
    onClose();
    setNewPrice(price);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {user && user.status === 'success' && (
        <PopUpBasic
          type="short"
          title={t('NewTradingPhotoCards.priceChangePopUpTitle')}
          description={t('NewTradingPhotoCards.priceChangePopUpDescription')}
          primaryButtonText={t('NewTradingPhotoCards.priceChangePopUpPrimaryButtonText')}
          secondaryButtonText={t('NewTradingPhotoCards.priceChangePopUpSecondaryButtonText')}
          onPrimaryButtonClick={handleEditCancel}
          onSecondaryButtonClick={handleEditConfirm}
          content={
            <div className="relative">
              {/* #EDF2F7, #212223은 따로 정의되어 있지 않아 하드코딩으로 작성 */}
              <CurrencyInput
                className="w-full h-[54px] bg-[#EDF2F7] dark:bg-[#212223] rounded-[12px] px-[16px] text-text-main-lv2 font-semibold text-[17px] focus:outline-none caret-primary"
                disabled={false}
                allowNegativeValue={false}
                defaultValue={price}
                placeholder={t('NewTradingPhotoCards.priceChangePopUpInputPlaceholder') as string}
                value={newPrice}
                onValueChange={(value) => setNewPrice(value ?? '')}
                intlConfig={intlConfig(user.data) as IntlConfig}
              />
            </div>
          }
          className="w-[311px] h-[248px]"
        />
      )}
    </div>
  );
};

export default PriceChangePopUp;
